<template>
  <v-form ref="aimSectionForm" class="section-title-cnr">
    <RichTextEditor
      :canShowDiffIcon="canShowDiffIcon"
      :isDiffChanged="isAimDescriptionChanged"
      fieldIdentifier="aim.description"
      :placeholder="AppTexts.AIM_DESCRIPTION"
      v-model="lessonPlanData.aim.description"
      :showValidationError="true"
      :readonly="!isNotReadOnly"
      :counter="250"
      :includeOnlyToolBarActions="BASIC_TOOLS"
    />
    <BlockTitle :title="AppTexts.KEYWORDS_WE_WILL_USE" />
    <Keywords
      class="mgn-Bm"
      :items="lessonPlanData.keywords"
      :addKeyword="addKeyword"
      :deleteKeyword="deleteKeyword"
      :placeholder="AppTexts.KEYWORD"
      :descriptionPlaceholder="AppTexts.KEYWORD_DESCRIPTION"
      :canShowDiffIcon="canShowDiffIcon"
      :keywordsDiff="keywordsDiff"
      :isNotReadOnly="isNotReadOnly"
      :maxNameLength="33"
      :maxDescriptionLength="100"
    />
    <BlockTitle :title="AppTexts.RESOURCES" />
    <Resources
      class="mgn-Bs"
      :items="lessonPlanData.aim.resources"
      :addResource="addResource"
      :deleteResource="deleteResource"
      withAdd
      :placeholder="AppTexts.RESOURCE_NAME"
      :isRequired="false"
      :label="AppTexts.SELECT_RESOURCE"
      :descriptionPlaceholder="AppTexts.RESOURCE_DESCRIPTION"
      :error="resourcesError"
      :showImageBrief="showImageBrief"
      :isAssetUploadRequired="isAssetUploadRequired"
      :acceptableFileType="acceptableFileType"
      :resourcesSignedUrls="aimSignedUrls.resources"
      :resourcesDiff="aimDiff.resources || []"
      :canShowDiffIcon="canShowDiffIcon"
      :isNotReadOnly="isNotReadOnly"
      :fileValidators="fileValidators"
      :maxNameLength="100"
      :canFinalizeAsset="true"
      :canAppproveAsset="canApproveAsset"
    />
    <div />
    <!-- todo: check teacher_tip for "Aim" -->
  </v-form>
</template>

<script>
import Keywords from '@/components/inputs/Keywords';
import Resources from '@/components/inputs/Resources';
import BlockTitle from '@/components/inputs/BlockTitle';
import AppTexts from '@/constants/AppTexts';
import Errors from '@/constants/Errors';
import { AIM_BLOCK_KEY_OF_STATE_LP_DATA } from '@/constants/LessonPlan';
import RichTextEditor, { BASIC_TOOLS } from '@/components/RTE/RichTextEditor.vue';

export default {
  name: 'ActionSection',
  components: {
    RichTextEditor,
    Keywords,
    Resources,
    BlockTitle
  },
  data() {
    return {
      AppTexts,
      Errors,
      AIM_BLOCK_KEY_OF_STATE_LP_DATA,
      BASIC_TOOLS,
    };
  },
  props: {
    lessonPlanData: {
      type: Object,
      required: true
    },
    addResource: {
      type: Function,
      required: true
    },
    deleteResource: {
      type: Function,
      required: true
    },
    addKeyword: {
      type: Function,
      required: true
    },
    deleteKeyword: {
      type: Function,
      required: true
    },
    resourcesError: {
      type: String,
      required: true
    },
    showImageBrief: {
      type: Boolean,
      required: true
    },
    isAssetUploadRequired: {
      type: Boolean,
      required: false,
      default: false
    },
    aimSignedUrls: {
      type: Object,
      required: true
    },
    aimDiff: {
      type: Object,
      required: true
    },
    keywordsDiff: {
      type: Array,
      required: true
    },
    canShowDiffIcon: {
      type: Boolean,
      required: true
    },
    isNotReadOnly: {
      type: Boolean,
      required: false,
      default: true
    },
    acceptableFileType: {
      type: String,
      required: false,
      default: null
    },
    fileValidators: {
      type: Array,
      required: false,
      default: () => []
    },
    canApproveAsset: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    isAimDescriptionChanged() {
      try {
        if (this.canShowDiffIcon) {
          return this.aimDiff.description.isChanged === true;
        }
      } catch (error) {
        return false;
      }

      return false;
    }
  }
};
</script>
